import { useState } from "react";
import { Link } from "react-router-dom";

import ReactMarkdown from 'react-markdown';
import { FaCaretDown, FaCaretRight, FaArrowRight, FaArrowLeft } from "react-icons/fa6";

import './components.css';
import './colors.css';
import './fonts.css';
import './spacing.css';

export const divFn = (className) => ({ children }) => {
    return <div className={ className }>{ children }</div>
}

export const PageWrapper = ({ sidebar, children }) => {
    const inside = <>
        <Link to='/'><div className='header-outer'>
            <div className='serif-title'>Merelogic</div>
        </div></Link>
        { children }
    </>

    if (sidebar) {
        return <div className='page-wrapper'>
            <div className='columns'>
                <div className='sidebar'>{ sidebar }</div>
                <div className='page-width'>{ inside }</div>
                <div className='invisible'>{ sidebar }</div>
            </div>
        </div>
    }

    return <div className='page-wrapper'>
        <div className='page-width'>{ inside }</div>
    </div>
}

export const SectionHeading = divFn('serif-h1 bottom-small');
export const DocPageHeading = divFn('serif-h2 top-med bottom-small');

export const Section = ({ children, title, scrollId }) => {
    return <div className='section-outer' id={ scrollId }>
        <SectionHeading>{ title }</SectionHeading>
        <div className='sans-body'>{ children }</div>
    </div>
}

export const DocSectionHeading = divFn('sans-heading-big top-med bottom-small');

export const Subsection = ({ children, title, to }) => {
    return <div className='bottom-large'>
        {
            to ?
            <Link to={ to }><div className='sans-heading top-med bottom-tiny link'>{ title }</div></Link> :
            <div className='sans-heading top-med bottom-tiny'>{ title }</div>
        }
        <div className='sans-body left-small'>{ children }</div>
    </div>
}

export const CollapseSubsection = ({ children, title, to, image, alt }) => {
    const [ collapsed, setCollapsed ] = useState(true);

    const caret = (
        collapsed ?
        <FaCaretRight size={20} style={{ verticalAlign: "middle" }} onClick={ () => setCollapsed(false)} /> :
        <FaCaretDown size={20} style={{ verticalAlign: "middle" }}  onClick={ () => setCollapsed(true)}/>
    );

    const imageStuff = (
        image ?
        <img
            src={ image }
            alt={ alt }
            className='image-small'
        /> : null
    );

    return <div className={ collapsed ? '' : 'bottom-large'}>
        {
            to ?
            <Link to={ to }><div className='sans-heading top-small bottom-tiny link'>{ caret } {imageStuff} { title }</div></Link> :
            <div className='sans-heading top-small bottom-tiny'>{ caret } {imageStuff} { title }</div>
        }
        {
            collapsed ? null :
            <div className='sans-body left-large top-small'>{ children }</div>
        }
    </div>
}

export const MDParagraph = ({ children }) => {
    return <div className='sans-body'>
        <ReactMarkdown>{ children }</ReactMarkdown>
    </div>
}

export const EmailLink = () => {
    return <span className='no-break'><Link to='mailto:jesse@merelogic.net'>jesse@merelogic.net</Link></span>
}

export const FancyLink = ({ children, to, direction }) => {
    return <Link className='sans-heading' to={ to }>
        {
            direction === 'left' ? <FaArrowLeft size={20} style={{ verticalAlign: "middle" }} /> : null
        } {
            children
        } {
            direction === 'right' ? <FaArrowRight size={20} style={{ verticalAlign: "middle" }} /> : null
        }
    </Link>
}

export const SuperTitle = divFn('serif-h2 centered-text')
export const Title = divFn('serif-h1 dark centered-text')
export const Line = divFn('sans-body bottom-tiny');
export const CenteredText = divFn('sans-heading top-huge bottom-large centered-text')
export const Paragraph = divFn('sans-body bottom-small narrow-margins');
export const Columns = divFn('columns')